import { ReducerCreators } from '@reduxjs/toolkit';
import { AudiencesState } from '../types';

export const setAllProfilesSearch = (create: ReducerCreators<AudiencesState>) =>
  create.reducer<string>((state, action) => {
    state.allProfiles.search = action.payload;
  });
